import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ApiService } from '@core/api.service';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { ProjectService } from '@features/project/project.service';
import { ToasterService } from '@ui-kit/app-toast/toaster.service';
import { BtnLoaderModule } from '@ui-kit/btn-loader/btn-loader.module';
import { FormControlErrorModule } from '@ui-kit/directives/form-control-error/form-control-error.module';
import { handleError } from '@ui-kit/utility/handleHttpErrorResponse';
import { Collection } from 'collection';
import { CollectionModel } from 'collection';

@Component({
  selector: 'create-task',
  templateUrl: './create-task.component.html',
  styleUrls: ['./create-task.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FormControlErrorModule, BtnLoaderModule, TranslateUiModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateTaskComponent {
  taskName = new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]);
  taskCollection: CollectionModel;

  get nameControlError() {
    const nameControl = this.taskName;
    return nameControl.touched && nameControl.errors;
  }

  close(): void {
    this._dialogRef.close();
  }

  private create(): void {
    this.taskCollection.createItem({ data: { name: this.taskName.value, project_id: this.data.project_id } }).subscribe(
      (res) => {
        this.data.subject.next(res.data);
        this._dialogRef.close();
        this._toastService.show({
          type: 'success',
          message: marker('Task is successfully created')
        });
      },
      (err) => {
        const errorResponse = err.error;
        handleError(errorResponse, this._toastService);
      }
    );
  }

  submit(): void {
    if (this.taskName.valid) {
      this.create();
    } else {
      this.taskName.markAsTouched({ onlySelf: true });
    }
  }

  constructor(
    private _elemRef: ElementRef,
    private _api: ApiService,
    private _toastService: ToasterService,
    private _projectService: ProjectService,
    public _dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.taskCollection = new Collection({
      api: this._api.tasks
    });
  }
}
